"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pinoConsoleLogHandler = void 0;
var _ansis = _interopRequireDefault(require("ansis"));
var _SeverityLevels = require("../../types/SeverityLevels");
var _isObject = require("../isObject");
var _stringifyErrorObject = require("../stringifyErrorObject");
var _stringifyObject = require("../stringifyObject");
/* eslint-disable no-console -- this is console transport handler which is designed to use console */ var NEWLINE_CHAR = '\r\n';
// @ts-expect-error -- this won't fail anything, but will be defined when on edge
var isInEdgeRuntime = typeof EdgeRuntime === 'string';
var isInNodeRuntime = !isInEdgeRuntime && typeof window === 'undefined';
var _obj;
var levelToColoretteFunctionName = (_obj = {}, _define_property(_obj, _SeverityLevels.SeverityLevels.INFO, _ansis.default.blue), _define_property(_obj, _SeverityLevels.SeverityLevels.METRIC, _ansis.default.green), _define_property(_obj, _SeverityLevels.SeverityLevels.ERROR, _ansis.default.red), _define_property(_obj, _SeverityLevels.SeverityLevels.WARN, _ansis.default.yellow), _define_property(_obj, _SeverityLevels.SeverityLevels.DEBUG, _ansis.default.gray.bgWhite), _obj);
var levelToConsoleMethod;
var formatTime = function(time) {
    return new Intl.DateTimeFormat('en-US', {
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        fractionalSecondDigits: 3,
        hour12: false
    }).format(new Date(time));
};
var logLevelToLabel = Object.fromEntries(Object.entries(_SeverityLevels.SeverityLevels));
var pinoConsoleLogHandler = function(_param) {
    var time = _param.time, userMessage = _param.msg, level = _param.level, properties = _object_without_properties(_param, [
        "time",
        "msg",
        "level"
    ]);
    var _obj;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- initialized here because of tests and mocking of console methods would not apply when defined globally
    levelToConsoleMethod !== null && levelToConsoleMethod !== void 0 ? levelToConsoleMethod : levelToConsoleMethod = (_obj = {}, _define_property(_obj, _SeverityLevels.SeverityLevels.INFO, console.info), _define_property(_obj, _SeverityLevels.SeverityLevels.METRIC, console.debug), _define_property(_obj, _SeverityLevels.SeverityLevels.ERROR, console.error), _define_property(_obj, _SeverityLevels.SeverityLevels.WARN, console.warn), _define_property(_obj, _SeverityLevels.SeverityLevels.DEBUG, console.debug), _obj);
    // console.log({ time, userMessage, level, properties });
    var formattedTime = "[".concat(formatTime(time), "]");
    var logLinePrefix = "".concat(formattedTime, " (").concat(logLevelToLabel[level], "):");
    if (isInEdgeRuntime || isInNodeRuntime) {
        logLinePrefix = levelToColoretteFunctionName[level](logLinePrefix);
    }
    var logLine = "".concat(logLinePrefix, " ").concat(userMessage);
    if (Object.keys(properties).length > 0) {
        if (isInNodeRuntime) {
            // Space to divide the metadata from the message
            logLine += ' ';
            // Checking that property "error" is an object should be enough - when copying to worker thread the error prototype is lost
            if ((0, _isObject.isObject)(properties.error)) {
                var error = properties.error, propertiesWithoutError = _object_without_properties(properties, [
                    "error"
                ]);
                logLine += _ansis.default.dim((0, _stringifyObject.stringifyObject)(propertiesWithoutError, undefined, true));
                logLine += NEWLINE_CHAR;
                logLine += (0, _stringifyErrorObject.stringifyErrorObject)(error);
            } else {
                // Dim metadata a little bit for the user to easily search in the logs
                logLine += _ansis.default.dim((0, _stringifyObject.stringifyObject)(properties, undefined, true));
            }
        } else {
            // Add newline for browser only, because of readability
            logLine += NEWLINE_CHAR;
        }
    }
    var logParams = [
        logLine
    ];
    // In browser we want to leverage native object searching
    // which is better than printing object itself
    if (!isInEdgeRuntime && !isInNodeRuntime) {
        logParams.push(properties);
    }
    // Use only console.log for node, because node could create trace for that log if specific method is used.
    var logMethodForLevel = isInNodeRuntime ? console.log : levelToConsoleMethod[level];
    logMethodForLevel.apply(void 0, _to_consumable_array(logParams));
};
exports.pinoConsoleLogHandler = pinoConsoleLogHandler; //# sourceMappingURL=pinoConsoleLogHandler.js.map
